export { fetchProductFromHandle, fetchProductsFromHandles } from './product';
